import { ElementRef, Injectable, effect, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import Map from '@arcgis/core/Map';
import { NGXLogger } from 'ngx-logger';
import { Observable, ReplaySubject, switchMap } from 'rxjs';
import { store } from '../../jmkw.store';
import { ViewConfig, EsriViewType, LayerResults } from '@jeppesen-foreflight/jmkw-types';
import { MapService } from './map-view/map/map.service';
import { ViewService } from './map-view/views/views.service';
import { LayerFactory } from './layer/layer-factory.service';
import { DialogAutoCloseService } from './dialog-auto-close.service';

@Injectable({
  providedIn: 'root'
})
export class ArcgisService {
  private readonly _logger = inject(NGXLogger);
  private readonly _dialogAutoClose = inject(DialogAutoCloseService);

  private readonly _viewsLoaded$ = new ReplaySubject<
    Record<EsriViewType, ViewConfig>
  >();
  public viewsLoaded$ = this._viewsLoaded$.asObservable();
  public mapLoaded$: Observable<Map>;
  public layersLoaded$?: Observable<LayerResults>;

  constructor(
    private readonly _layerFactory: LayerFactory,
    private readonly _mapService: MapService,
    private readonly _viewService: ViewService
  ) {
    this.mapLoaded$ = toObservable(store.map);
    this.layersLoaded$ = toObservable(store.pluginMap).pipe(
      switchMap((pluginMap) => this._layerFactory.addPluginLayers$(pluginMap))
    );

    const views = this._viewService.init(this._mapService.$map());
    this._viewsLoaded$.next(views);

    this._trackMapView();

    // Initialize dialog auto-close to prevent ArcGIS auth dialogs from blocking UI
    this._dialogAutoClose.initialize();
  }

  public toggleViewContainer(el: ElementRef, EsriViewType: EsriViewType): void {
    this._viewService.toggleViewContainer(el, EsriViewType);
  }

  private _trackMapView(): void {
    effect(() => {
      this._logger.trace('[ArcgisService] $mapView:', store.views['2D'].view());
    });
  }
}
